













import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
@Component
export default class SearchInput extends Vue{
    @Prop() private placeholderText!: string;
    @Prop() private value!: string;

    // @Watch("value")
    // valueChanged(){
    //     alert("value");
    //      this.$emit('input', this.value) // update block in parent component

    // }

    changed(obj:any) {
        this.$emit('input', obj) // update block in parent component
    }
    
}
